import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=2ca3c559"
import script from "./EditIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./EditIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca3c559')) {
      api.createRecord('2ca3c559', component.options)
    } else {
      api.reload('2ca3c559', component.options)
    }
    module.hot.accept("./EditIcon.vue?vue&type=template&id=2ca3c559", function () {
      api.rerender('2ca3c559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/EditIcon.vue"
export default component.exports